// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { EStatus } from '../../../node/repositories/newbuilding-card/entities/reviews/Like';
import { IOrderStatus } from '../../types/newbuilding/flatViewOrderInfo';
import { TComparisonStatus } from '../../types/newbuilding';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ENewbuildingActionTypes {
  SetFavorite = 'newbuilding/setFavorite',
  SetFlatViewOrder = 'newbuilding/setFlatViewOrder',
  SetReviewReaction = 'newbuilding/setReviewReaction',
  SetComparisonStatus = 'newbuilding/setComparisonStatus',
}

export type TSetReviewReactionActionPayload = {
  reviewId: string;
  type: EStatus;
};

export type TSetFavorite = ITypedReduxAction<ENewbuildingActionTypes.SetFavorite, boolean>;

export type TSetFlatViewOrder = ITypedReduxAction<ENewbuildingActionTypes.SetFlatViewOrder, IOrderStatus>;

export type TSetComparisonStatus = ITypedReduxAction<
  ENewbuildingActionTypes.SetComparisonStatus,
  TComparisonStatus | null | undefined
>;

export type TSetReviewReaction = ITypedReduxAction<
  ENewbuildingActionTypes.SetReviewReaction,
  TSetReviewReactionActionPayload
>;

/**
 * Redux action, который записывает в store статус избранного
 * @param state boolean
 */
export const setFavorite: (state: boolean) => TSetFavorite = actionGenerator<
  ENewbuildingActionTypes.SetFavorite,
  boolean
>(ENewbuildingActionTypes.SetFavorite);

export const setFlatViewOrder = actionGenerator<ENewbuildingActionTypes.SetFlatViewOrder, IOrderStatus>(
  ENewbuildingActionTypes.SetFlatViewOrder,
);

export const setComparisonStatus = actionGenerator<
  ENewbuildingActionTypes.SetComparisonStatus,
  TComparisonStatus | null | undefined
>(ENewbuildingActionTypes.SetComparisonStatus);

/**
 * Redux action, который записывает в store новый лайк/дизлайк пользователя
 */
export const setReviewReactionAction: (payload: TSetReviewReactionActionPayload) => TSetReviewReaction =
  actionGenerator<ENewbuildingActionTypes.SetReviewReaction, TSetReviewReactionActionPayload>(
    ENewbuildingActionTypes.SetReviewReaction,
  );
